import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNER_REPORT } from "./apiRoutes";

interface UseGetOwnersReportExportProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getOwnersReportExport = async (data: any) =>
  await axiosAuth.post(`${OWNER_REPORT}/export`, data, {
    responseType: "blob",
  });

const useGetOwnersReportExport = ({
  data,
  queryParams,
}: UseGetOwnersReportExportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["owners-report-export"],
    queryFn: () => getOwnersReportExport(data),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetOwnersReportExport;
